import { render, staticRenderFns } from "./WorkloadDetailReleasedIcon.vue?vue&type=template&id=34ba1cf5"
import script from "./WorkloadDetailReleasedIcon.vue?vue&type=script&lang=js"
export * from "./WorkloadDetailReleasedIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports